import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import styles from './CssModules/PolicyField.module.css';

const PolicyField = ({
    fieldTitle,
    isExcludedField,
    isAccessingField,
    isSectionContainer,
    children,
    fieldClass,
    tooltipText
}) => {
    return (
        <div
            className={`${styles.policyField} ${isSectionContainer ? styles.policySectionContainer : ''} ${
                fieldClass ? fieldClass : ''
            }`}>
            <div
                className={`${styles.policyFieldTitle}  
                ${isExcludedField ? styles.excludedTitle : ''} 
                ${isAccessingField ? styles.accessingField : ''}  
                ${isSectionContainer ? styles.policySectionTitle : ''}`}>
                {fieldTitle}
                {tooltipText && (
                    <Tooltip
                        title={tooltipText}
                        arrow={true}
                        classes={{ tooltip: 'generic-tooltip' }}
                        placement="right">
                        <div className="moreInfoIcon" />
                    </Tooltip>
                )}
            </div>
            {children}
        </div>
    );
};

export default PolicyField;
